import { createSlice } from '@reduxjs/toolkit';

export const productsSlice = createSlice({
	name: 'products',
	initialState: {
		data: null,
	},
	reducers: {
		addProducts: function (state, action) {
			state.data = action.payload;
		},
	},
});

export const { addProducts } = productsSlice.actions;
export default productsSlice.reducer;
